const SESSION_KEYS = [
  'CognitoSignInState.challengeName',
  'CognitoSignInState.signInSession',
  'CognitoSignInState.expiry',
  'CognitoSignInState.username',
] as const;

async function hashEmail(email: string): Promise<string> {
  const encoded = new TextEncoder().encode(email.toLowerCase());
  const buffer = await crypto.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

function getCognitoSignInSession(): Record<string, string | number> {
  const session: Record<string, string | number> = {};
  for (const key of SESSION_KEYS) {
    const val = sessionStorage.getItem(key);
    if (val !== null) session[key] = val;
  }
  return session;
}

export async function persistLoginSession(
  email: string,
  path: string,
): Promise<void> {
  const appsyncUrl = process.env.NEXT_PUBLIC_APPSYNC_URL;
  const apiKey = process.env.NEXT_PUBLIC_APPSYNC_API_KEY;

  if (!appsyncUrl || !apiKey) {
    console.warn('persistLoginSession: missing AppSync env vars, skipping');
    return;
  }

  const sessionData = getCognitoSignInSession();
  if (Object.keys(sessionData).length === 0) return;

  const id = await hashEmail(email);

  await fetch(appsyncUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
    },
    body: JSON.stringify({
      query: `mutation PersistLoginSession($id: String!, $sessionData: String!, $path: String) {
        persistLoginSession(id: $id, sessionData: $sessionData, path: $path) { id }
      }`,
      variables: {
        id,
        sessionData: JSON.stringify(sessionData),
        path,
      },
    }),
  });
}
